import { ChangeEvent, FormEvent, useEffect, useState } from 'react';
import { useOperator } from '../contexts/OperatorContext';
import { getEventValueAsType } from '../lib/formatters';

export function useForm<Type extends object>(
  initialState: Type,
  callback: () => any
) {
  const [values, setValues] = useState(initialState);
  const [active, setActive] = useState(false);
  const operator = useOperator();

  useEffect(() => {
    setValues(initialState);
  }, [operator.id]);

  const onChange = (event: ChangeEvent<any>) => {
    setActive(true);
    setValues(
      Object.assign({}, values, {
        [event.target.name]: getEventValueAsType(event),
      })
    );
  };

  const onSubmit = async (event?: FormEvent<HTMLFormElement>) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    await callback();
  };

  const resetForm = () => {
    setActive(false);
    setValues(initialState);
  };

  const updateField = (key: keyof Type, value: any) => {
    setActive(true);
    setValues((values) => Object.assign({}, values, { [key]: value }));
  };

  const updateInitialState = (state: Type) => {
    setActive(true);
    setValues(Object.assign({}, values, state));
  };

  return {
    active,
    onChange,
    onSubmit,
    values,
    resetForm,
    updateField,
    updateInitialState,
  };
}
